import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'currencyFormat'
})
export class CurrencyFormatPipe implements PipeTransform {

  transform(value: number): string {
    if (value != null) {
      return '$' + value.toLocaleString('en-US');
    }
    return '$0';
  }

}
